import React, { useEffect, useRef } from "react";
import {
  IoMail,
  IoLogoFacebook,
  IoLogoTwitter,
  IoLogoYoutube,
  IoLogoTiktok,
} from "react-icons/io5";
import noImg from "../../images/pictures/no-profile.png";

function FrontCard({ display, color }) {
  const bordercolorFront = useRef();

  useEffect(() => {
    bordercolorFront.current.style.backgroundColor = color;
  }, [color]);

  return (
    <div className={`card ${display.backgroundDiv} ${display.text}`}>
      <div className="head-card">
        <span className="darkdivColor"></span>
      </div>
      <div className="body-card">
        <div className="photo-wrap">
          <div className={`photo`} ref={bordercolorFront}>
            <img src={noImg} alt="Profile" title="Profile" />
          </div>
        </div>
        <h2 className={`textTitle ${display.text} textBold"`}>Your Name</h2>
        <p className={`text ${display.text} textMedium`}>About You</p>
        <div className="message">
          <p className={`${display.button} textSmall textMedium`}>
            Get In Touch!
          </p>
        </div>
        <div className="social-link">
          <IoMail
            className="icon-link"
            size="1em"
            style={{ "--hoverColor": color }}
          />
          <IoLogoFacebook
            className="icon-link"
            size="1em"
            style={{ "--hoverColor": color }}
          />
          <IoLogoTiktok
            className="icon-link"
            size="1em"
            style={{ "--hoverColor": color }}
          />
          <IoLogoTwitter
            className="icon-link"
            size="1em"
            style={{ "--hoverColor": color }}
          />
          <IoLogoYoutube
            className="icon-link"
            size="1em"
            style={{ "--hoverColor": color }}
          />
        </div>
      </div>
    </div>
  );
}

export default FrontCard;
